// The About page: what the application is, and where to send comments.
//
// Static, and fetches nothing. Its words are the "About Barrier Tracker"
// document's, less how to reach the application: anybody reading this page has
// already found the address, signed in and been given access.

import { Screen } from './Screen';

export const HELP_EMAIL = 'ithelp@layerzero.com';

export function AboutScreen() {
  return (
    <Screen title="About">
      <div className="about">
        <h2>What it is</h2>
        <p>
          Barrier Tracker is LayerZero's web application for tracking production barriers: the issues that hold up an
          order, who owns each action, and when it closes. It replaces the "Production Barrier Tracker" AppSheet app and
          keeps the same views, including the barrier dashboards, the HOT list, interplant transfers, daily and two-week
          production, and open orders.
        </p>

        <h2>Comments, questions or suggestions</h2>
        <p>
          Send them to <a href={`mailto:${HELP_EMAIL}`}>{HELP_EMAIL}</a>. Please include a short description and, where it
          helps, a screenshot of the screen you were on.
        </p>
      </div>
    </Screen>
  );
}
